import { Fragment, ReactNode } from 'react'

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** Wraps every case-insensitive occurrence of the query in a brand-tinted mark. */
// Currently unreferenced: kept (with the highlightQuery props and the
// menu.searchPlaceholder/noResults messages) for the planned return of menu search.
export const highlightMatch = (text: string, query: string): ReactNode => {
    const trimmedQuery = query.trim()

    if (!trimmedQuery) return text

    const parts = text.split(new RegExp(`(${escapeRegExp(trimmedQuery)})`, 'gi'))

    return parts.map((part, index) => {
        const isMatch = part.toLowerCase() === trimmedQuery.toLowerCase()

        if (!isMatch) return <Fragment key={index + part}>{part}</Fragment>

        return (
            <mark key={index + part} className="bg-bg-overlay-brand rounded-[2px] text-inherit">
                {part}
            </mark>
        )
    })
}
